import { type SubmitEvent } from 'react'

import { useMarketplacePartnerRegisterPageFormApiPostMutationV1 } from '../api/swr/useMarketplacePartnerRegisterPageFormApiPostMutationV1'
import { useMarketplacePartnerRegisterPageContext } from '../components/marketplacePartnerRegisterPageContext'
import { marketplacePartnerRegisterPageFormScrollToFirstFormError } from '../marketplacePartnerRegisterPageFormScrollToFirstFormError'

export const useMarketplacePartnerRegisterPageSendEmail = (): {
  errors: Error | undefined
  handleSendEmail: (event: SubmitEvent) => Promise<void>
  isMutating: boolean
} => {
  const marketplacePartnerRegisterPageApiPostMutationV1 =
    useMarketplacePartnerRegisterPageFormApiPostMutationV1()
  const { formRef, formState, resetForm, setIsFormValid } =
    useMarketplacePartnerRegisterPageContext()
  formState.use()

  const handleSendEmail = async (event: SubmitEvent): Promise<void> => {
    event.preventDefault()
    const valid = formState.isValid({ validate: true })
    setIsFormValid(valid)
    if (!valid) {
      requestAnimationFrame(() => {
        if (formRef.current) {
          marketplacePartnerRegisterPageFormScrollToFirstFormError(
            formRef.current,
          )
        }
      })

      return
    }
    if (marketplacePartnerRegisterPageApiPostMutationV1.isMutating) {
      return
    }
    try {
      await marketplacePartnerRegisterPageApiPostMutationV1.trigger()
      resetForm()
    } catch {
      // void -- error will be handled in MarketplacePartnerRegisterPageFormMessages component
    }
  }

  return {
    errors: Error.isError(marketplacePartnerRegisterPageApiPostMutationV1.error)
      ? marketplacePartnerRegisterPageApiPostMutationV1.error
      : undefined,
    handleSendEmail,
    isMutating: marketplacePartnerRegisterPageApiPostMutationV1.isMutating,
  }
}
